<template>
  <div class="share">
    <share></share>
  </div>
</template>

<script>
// @ is an alias to /src
import Share from '@/components/share/WapShare.vue'
export default {
  name: '',
   components: {
     share: Share
  }
}
</script>

<style scoped>
 .share{
   width: 100vw;
   height: 100vh;
 }
</style>
